import { render, staticRenderFns } from "./address-native.vue?vue&type=template&id=3130e8ac"
import script from "./address-native.vue?vue&type=script&lang=js"
export * from "./address-native.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports